module.exports = __webpack_public_path__ + "img/9_002.f7141b9c.webp";